import { render, staticRenderFns } from "./userWallet.vue?vue&type=template&id=1bbbc652&scoped=true&"
import script from "./userWallet.vue?vue&type=script&lang=js&"
export * from "./userWallet.vue?vue&type=script&lang=js&"
import style0 from "./userWallet.vue?vue&type=style&index=0&id=1bbbc652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbbc652",
  null
  
)

export default component.exports